import { createSlice } from "@reduxjs/toolkit"
import {
  addIngredient,
  deleteIngredient,
  getIngredientDetails,
  getIngredients,
  getIngredientsList,
  updateIngredient,
  updateIngredientStatus,
} from "store/actions/ingredientAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  ingredients: [],
  ingredientDetails: {},
  ingredientsList: [],
}

const usersSlice = createSlice({
  name: "ingredients",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL INGREDIENTS
    builder
      .addCase(getIngredients.pending, state => {
        state.loading = true
      })
      .addCase(getIngredients.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.ingredients = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getIngredients.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL INGREDIENTS LIST
    builder
      .addCase(getIngredientsList.pending, state => {
        state.loading = true
      })
      .addCase(getIngredientsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.ingredientsList = data
        }
      })
      .addCase(getIngredientsList.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE INGREDIENTS STATUS
    builder
      .addCase(updateIngredientStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateIngredientStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.ingredients = state.ingredients.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateIngredientStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    //   DELETE INGREDIENT
    builder
      .addCase(deleteIngredient.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteIngredient.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.ingredients = state.ingredients.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteIngredient.rejected, (state, action) => {
        state.isLoading = false
      })

    //  ADD INGREDIENT
    builder
      .addCase(addIngredient.pending, state => {
        state.isLoading = true
      })
      .addCase(addIngredient.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addIngredient.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE INGREDIENT
    builder
      .addCase(updateIngredient.pending, state => {
        state.isLoading = true
      })
      .addCase(updateIngredient.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateIngredient.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET INGREDIENT DETAILS
    builder
      .addCase(getIngredientDetails.pending, state => {
        state.loading = true
        state.ingredientDetails = {}
      })
      .addCase(getIngredientDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.ingredientDetails = data
        }
      })
      .addCase(getIngredientDetails.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
